var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header-pane',[(_vm.isPatientFeatureEnable && _vm.shouldShowPatientInformation)?_c('div',{staticClass:"header-pane-patient"},[_c('simple-patient-viewer',{attrs:{"patient":_vm.patient}}),_vm._v(" "),_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }